<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-width="85px" label-position="left">
        <el-form-item label="活动编号">
          <el-input v-model="searchForm.activityId" placeholder="请输入活动编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-autocomplete
          v-model="searchForm.name"
          :fetch-suggestions="querySearch"
          placeholder="请输入活动名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select v-model="searchForm.activityType" placeholder="请选择活动类型" :clearable="true">
            <el-option v-for="item in typeList" :label="item.text" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动状态">
          <el-select v-model="searchForm.activityStatus" clearable placeholder="请选择活动状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡服务">
          <el-select v-model="searchForm.subType" clearable placeholder="请选择开卡服务">
            <el-option label="不提供" :value="0"></el-option>
            <el-option label="上门开卡" :value="10"></el-option>
            <el-option label="网点开卡" :value="30"></el-option>
            <el-option label="上门/网点开卡" :value="40"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input v-model="searchForm.merchantCode" placeholder="请输入商户编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="对私税点承担" label-width="100px">
          <el-select v-model="searchForm.personTaxObj" clearable placeholder="请选择税点承担方">
            <el-option label="全部" value=""></el-option>
            <el-option label="商户" :value="0"></el-option>
            <el-option label="银行" :value="1"></el-option>
            <el-option label="一代" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <!-- <el-button :loading="exportLoading" @click="exportActivity">导出</el-button> -->
        <div>
          <!-- <auth-button opt="agent_activity_month_export" :plain="true" label="导出代理商活动数据【月返】" @click.native="toExportMonthActivity"></auth-button> -->
          <auth-button opt="activity_data_export" type="primary" label="导出活动商户信息" @click.native="exportActivityData"></auth-button>
          <auth-button opt="activity_config_data_export" type="primary" label="导出活动配置信息" @click.native="exportActivityConfigData"></auth-button>
        </div>
      </el-form>
    </module-card>
    <module-card title="活动管理">
      <auth-button type="primary" icon="el-icon-plus" label="创建活动" @click.native="toAddActivity"></auth-button>
      <el-table class="table" border :data="activityList" v-loading="searchLoading">
        <el-table-column
          label="活动编号"
          prop="code">
        </el-table-column>
        <el-table-column
          label="活动名称"
          prop="name">
        </el-table-column>
        <el-table-column
          label="活动类型"
          prop="type">
          <template slot-scope="scope">{{getTypeText(scope.row.type)}}</template>
        </el-table-column>
        <el-table-column
          label="小程序展示"
          prop="displaySwitch">
          <template slot-scope="scope">{{scope.row.displaySwitch === null || scope.row.displaySwitch === 1 ? '展示' : '不展示'}}</template>
        </el-table-column>
        <el-table-column
          label="开卡服务"
          prop="suportCard">
          <template slot-scope="scope">
            {{getSubTypeText(scope.row.subType)}}
          </template>
        </el-table-column>
        <el-table-column
          label="对私税点承担"
          prop="suportCard">
          <template slot-scope="scope">
            {{isBearTaxMap[scope.row.personTaxObj]}}
          </template>
        </el-table-column>
        <el-table-column
          label="活动状态"
          prop="activityStatus">
          <template slot-scope="scope">{{getStatusText(scope.row.activityStatus)}}</template>
        </el-table-column>
        <el-table-column
          label="最近操作时间"
          width="110"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          label="最近操作人"
          width="100"
          prop="operator">
        </el-table-column>
        <el-table-column
          label="操作"
          width="200">
          <template slot-scope="scope">
            <auth-button auth-type="span" label="编辑" opt="edit" @click.native="editActivity(scope.row)"></auth-button>
            <auth-button auth-type="span" label="详情" opt="detail" @click.native="checkDetails(scope.row)"></auth-button>
            <auth-button v-if="[10, 0, 20, 30, 40].includes(scope.row.subType)" auth-type="span" label="商户管理" opt="market_merchant_manage" @click.native="merchantManage(scope.row)"></auth-button>
            <auth-button v-if="[20, 30].includes(scope.row.type)" auth-type="span" label="额度包管理" opt="quota_merchant_manage" @click.native="quotaMerchantManage(scope.row)"></auth-button>
            <auth-button v-show="[1, 2].includes(scope.row.activityStatus)" auth-type="span" label="下架活动" opt="activity_off" @click.native="activityOff(scope.row)"></auth-button>
            <auth-button v-if="scope.row.activityStatus === 3" auth-type="span" label="重新上架" opt="activity_off" @click.native="activityOn(scope.row)"></auth-button>
            <auth-button v-if="scope.row.activityStatus === 3" auth-type="span" label="删除活动" opt="activity_delete" @click.native="activityDelete(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :count="total"
        :page-no="searchForm.pageNo"
        :size="searchForm.pageSize"
        :edit-size="true"
        @changePage="value => { searchForm.pageNo = value;getList() }"
        @changeSize="value => { searchForm.pageSize = value;searchForm.pageNo = 1;getList() }"
      ></pagination>
    </module-card>
    <dialog-info :title="isCheckDetail? '详情' : (activityForm.code ? '编辑' : '创建活动')"
    :visible.sync="showDialog"
    :confirmLoading="editLoading"
    :cancel-text="isCheckDetail? '关闭' : '取消'"
    :show-confirm-btn="!isCheckDetail"
    @confirm="submitActivity"
    @close="closeActivityForm"
    :dialog-width="750">
      <el-form ref="activityForm" :model="activityForm" :rules="ruleData" label-width="100px" label-position="left" :disabled="isCheckDetail" class="activityForm">
      <!-- <el-form ref="activityForm" :model="activityForm" :rules="ruleData" label-width="85px" label-position="top" :disabled="isCheckDetail" class="activityForm"> -->
        <el-form-item prop="name" label="活动名称">
          <el-input v-model="activityForm.name" placeholder="请输入活动名称"></el-input>
        </el-form-item>
        <el-form-item label="活动编号" v-show="activityForm.code !== ''">
          <el-input v-model.trim="activityForm.code" disabled></el-input>
        </el-form-item>
        <el-form-item label="活动类型" required>
          <div>
            <el-select v-model="activityForm.type" :disabled="activityForm.code !== '' && activityForm.type === 10">
              <el-option v-for="item in typeList" :label="item.text" :value="item.id" :key="item.id" :disabled="activityForm.code !== '' && item.id === 10"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="活动银行" required>
          <el-select v-model="activityForm.bankCode" :disabled="activityForm.code !== ''" filterable>
            <el-option v-for="item in bankList" :label="item.name" :value="item.code" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cardBinLength" label="卡bin位数">
          <el-input v-model.trim="activityForm.cardBinLength" placeholder="请输入1-16之间整数" maxlength="2"></el-input>
        </el-form-item>
        <el-form-item prop="cardBins" label="活动卡bin">
          <el-input type="textarea" v-model.trim="activityForm.cardBins" placeholder="请输入卡bin，用英文逗号,分隔" :rows="2"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="isBearTax" label="税点承担" label-width="110px">
          <el-radio-group v-model.trim="activityForm.isBearTax">
            <el-radio :label="1">银行</el-radio>
            <el-radio :label="0">商户</el-radio>
            <el-radio :label="2" >一代</el-radio >
          </el-radio-group>
        </el-form-item> -->
        <el-form-item prop="deductionType" label="额度包扣减模式" label-width="130px" required v-show="activityForm.type === 20">
          <el-radio-group v-model.trim="activityForm.deductionType">
            <el-radio :label="1">额度包扣减金额=商户补贴金额</el-radio>
            <el-radio :label="2">额度包扣减金额=银行出资金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="long-content">
          <el-table
            :data="taxConfig"
            :span-method="taxConfigSpanMethod"
            border
            class="tax-config-table"
            style="width: 100%; margin-top: 20px">
            <el-table-column
              prop="accountType"
              label="结算账户类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="taxer"
              label="税点承担">
              <template slot-scope="{row, $index}">
                <el-form-item v-if="$index === 0">
                  <el-radio-group v-model="activityForm.personTaxObj">
                    <el-radio v-for="item in taxerList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-else :prop="row.taxerKey">
                  <el-checkbox v-model="activityForm.enterpriseTaxer[row.taxerKey]">{{ row.taxer }}</el-checkbox>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              label="税点比例"
              prop="taxRate"
              width="220">
              <template slot-scope="{row, $index}">
                <el-form-item prop="personTaxCommission" v-if="$index === 0">
                  <div class="private_tax_rate">
                    <el-select v-model="activityForm.personTaxCommission" placeholder="请选择税点比例">
                      <el-option v-for="item in taxRateList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                    <span>%</span>
                  </div>
                </el-form-item>
                <el-form-item v-else :prop="row.taxRateKey">
                  <el-input placeholder="请输入0-30%税点" v-model.trim="activityForm[row.taxRateKey]" oninput="value=value.replace(/[^\d]/g,'')" :disabled="isCheckDetail">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
          <p>温馨提示：</p>
          <p>1. 商户对私结算税点承担支持单选，税点比列0%/6%/10%，必填；</p>
          <p>2. 商户对公结算税点承担支持单选/多选，税点比列支持0~30%的自定义配置，必填；</p>
          <p>3. 商户对公结算手续费补贴税点计算公式：（承担对象1税点比列+对象2税点比列+对象3税点比列）*手续费补贴金额=扣除税点 (税点数值小数点保留后两位)</p>
        </el-form-item>
        <!-- <el-form-item prop="taxPointRatio" label="税点比例">
          <el-select v-model="activityForm.taxPointRatio" placeholder="请输入发票税点比例">
            <el-option :value="0" label="0%"></el-option>
            <el-option :value="6" label="6%"></el-option>
            <el-option :value="10" label="10%"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="开卡服务" required>
          <el-radio-group v-model="activityForm.subType" :disabled="$store.state.userInfo.userType !== 0">
            <el-radio :label="0">不提供</el-radio>
            <el-radio :label="10">上门开卡</el-radio>
            <el-radio :label="30">网点开卡</el-radio>
            <el-radio :label="40">上门/网点开卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开卡要求" v-if="activityForm.subType !== 0">
          <el-checkbox-group v-model="openCardDemandList" :disabled="activityForm.code !== ''">
            <el-checkbox :label="1">社保</el-checkbox>
            <el-checkbox :label="10">居住证</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="settleType" label="补贴对象" required>
          <el-checkbox-group v-model="activityForm.settleType">
            <el-checkbox label="0" name="settleType">补贴给商户</el-checkbox>
            <el-checkbox :disabled="settleDisabled" label="10" name="settleType">补贴给代理商</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="小程序展示" required>
          <el-radio-group v-model="activityForm.displaySwitch">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动地区" required>
          <el-radio-group v-model="activityForm.isAllProvince">
            <el-radio :label="1">全国</el-radio>
            <el-radio :label="0">指定省市</el-radio>
          </el-radio-group>
          <address-select ref="addressForm" v-model="activityForm.activityAddress" :value="activityForm.activityAddress" :required="activityForm.isAllProvince === 0" :multiCity="true" :show-area="false" :readOnly="isCheckDetail || choseAllProvince" @getValue="getAddress"></address-select>
        </el-form-item>
        <el-form-item prop="capitalPoolCode" label="资金池编号" v-show="[20, 30].includes(activityForm.type)">
          <el-input v-model.trim="activityForm.capitalPoolCode" placeholder="请输入资金池编号"></el-input>
        </el-form-item>
        <el-form-item prop="advanceAgent" label="代理商垫资" v-show="[0].includes(this.$store.state.userInfo.userType) && [20, 30].includes(activityForm.type)" :class="activityForm.advanceType === 1 ? 'is-required' : ''">
          <el-radio-group v-model="activityForm.advanceType" @change="activityForm.advanceAgent = ''">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
          <el-input v-model.trim="activityForm.advanceAgent" placeholder="请输入代理商编号，多个则用英文逗号区分" :disabled="!activityForm.advanceType"></el-input>
        </el-form-item>
        <el-form-item label="设置补贴规则" v-show="[20, 30].includes(activityForm.type)" class="long-content">
          <el-table
            :data="subsidyTable"
            :span-method="editTemplateTableSpanMethod"
            :header-cell-style="hideHeader"
            :border="true"
            style="margin-left: 0px;"
            size="small">
            <el-table-column
              label="交易类型">
              <el-table-column
                label="交易类型"
                prop="tradeType">
              </el-table-column>
              <el-table-column
                label="交易类型"
                prop="secondType">
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="补贴费率"
              prop="subsidyRate">
              <template slot-scope="scope">
                <el-input-number v-model.trim="activityForm[scope.row.rateKey]" :min="0" :max="0.6" :precision="3" :controls="false" :disabled="isCheckDetail"></el-input-number>
                <!-- <input v-model.trim="activityForm[scope.row.rateKey]" @blur="onRateBlur(scope.row)" :disabled="isCheckDetail"/> -->
                <span>%</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 补贴金额限制0:存量初始,1:不限制,2:自定义 -->
        <el-form-item prop="allowanceAmountLimit" label="可补贴单笔交易金额范围"  v-show="[20, 30].includes(activityForm.type)" class="long-content" label-width="180px">
          <el-radio-group v-model="activityForm.allowanceAmountLimit">
            <el-radio :label="1">不限</el-radio>
            <el-radio :label="2">自定义</el-radio>
          </el-radio-group>
          <div class="input-number">
            <el-input-number v-model="activityForm.allowanceAmountMin" :min="0" size="small" :disabled="activityForm.allowanceAmountLimit === 1"></el-input-number>
            至
            <el-input-number v-model="activityForm.allowanceAmountMax" :min="activityForm.allowanceAmountMin" size="small" :disabled="activityForm.allowanceAmountLimit === 1"></el-input-number>
            元
          </div>
          <div v-show="[20, 30].includes(activityForm.type)" style="color: #888;margin-top: 8px;">范围内（含最低，最高金额）可进行补贴，超出范围不补贴</div>
        </el-form-item>
        <!-- <el-form-item prop="maxAllowance" label="刷卡借记卡单笔封顶手续费" v-show="[20, 30].includes(activityForm.type)" label-width="180px">
          <el-input v-model.trim="activityForm.maxAllowance">
            <template slot="append">元</template>
          </el-input>
        </el-form-item> -->
        <el-form-item label-width="300px" v-show="[20, 30].includes(activityForm.type)" label="借记卡刷卡单笔手续费补贴封顶值配置" class="long-content">
          <el-table
            :data="capConfig"
            :span-method="objectSpanMethod"
            border
            style="width: 100%; margin-top: 20px">
            <el-table-column
              prop="tradeType"
              label="刷卡交易卡类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="payWay"
              label="结算方式">
            </el-table-column>
            <el-table-column
              label="单笔手续费补贴封顶值"
              prop="maxSubsidy">
              <template slot-scope="{row}">
                <el-form-item :prop="row.subsidyKey">
                  <el-input v-model.trim="activityForm[row.subsidyKey]" oninput="value=value.replace(/[^\d]/g,'')" :disabled="isCheckDetail">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item prop="creditAllowanceCap" label="刷卡贷记卡补贴封顶手续费" v-show="[20, 30].includes(activityForm.type)" label-width="180px">
          <el-input v-model.trim="activityForm.creditAllowanceCap" :disabled="activityForm.code !== ''">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="对应补贴周期" v-show="[20, 30].includes(activityForm.type)">
          <div>
            <el-input-number v-model="activityForm.capMonthStart" :min="1" size="small" :disabled="activityForm.code !== ''"></el-input-number>
            至
            <el-input-number v-model="activityForm.capMonthEnd" :min="activityForm.capMonthStart" size="small" :disabled="activityForm.code !== ''"></el-input-number>
            个
          </div>
          <div v-show="[20, 30].includes(activityForm.type)" style="color: #888;margin-top: 8px;margin-left:-100px;">在额度包补贴周期范围内设置贷记卡补贴手续费封顶值（非单笔封顶值）</div>
        </el-form-item>
        <el-form-item prop="agentIds" label="活动代理商">
          <el-radio-group v-model="activityForm.agentScope" @change="$refs.activityForm.clearValidate('agentIds')">
            <el-radio :label="0">全部代理商可参加</el-radio>
            <el-radio :label="1">仅特定代理商可参加</el-radio>
          </el-radio-group>
          <el-input v-if="activityForm.agentScope === 0" disabled type="textarea" :rows="4" placeholder="请输入可参加的代理商编号，多个则用英文逗号区分"></el-input>
          <el-input v-if="activityForm.agentScope !== 0" v-model="activityForm.agentIds" type="textarea" :rows="4" placeholder="请输入可参加的代理商编号，多个则用英文逗号区分"></el-input>
        </el-form-item>
        <el-form-item prop="activityTime" label="活动时间">
          <date-range-picker class="activityTime" :value="activityForm.activityTime" @getChange="getTimeChange" align="center" :afterLimit="false"></date-range-picker>
        </el-form-item>
        <el-form-item prop="quotaPeriodType" label="额度包周期" required v-show="[20, 30].includes(activityForm.type)">
          <el-radio-group v-model="activityForm.quotaPeriodType" @change="onQuotaPeriodTypeChange" :disabled="activityForm.code !== ''">
            <el-radio :label="1">自然月</el-radio>
            <el-radio :label="2">跨月</el-radio>
          </el-radio-group>
          <div v-show="activityForm.quotaPeriodType === 2" class="period-date">每月
            <el-select v-model="activityForm.periodBeginDate" class="select-date" size="small" :disabled="activityForm.code !== ''">
              <el-option v-for="item in periodDateList" :key="item" :value="item" :label="item"></el-option>
            </el-select>
            号<span class="inner">至</span>下月
            <el-select :value="activityForm.periodBeginDate - 1" class="select-date" size="small" disabled>
              <el-option v-for="item in periodDateList" :key="item" :value="item" :label="item"></el-option>
            </el-select>
            号</div>
        </el-form-item>
        <el-form-item prop="desc" label="活动说明">
          <el-input type="textarea" v-model="activityForm.desc" :rows="3" placeholder="请输入活动规则等说明"></el-input>
        </el-form-item>
        <el-form-item prop="fileIds" label="活动政策">
          <input type="file" ref="file" @change="getFile($event, 'file')" style="display:none" multiple accept="application/pdf"/>
          <el-button type="text" @click="$refs.file.click()" :loading="uploadLoading" style="padding: 0;padding-right: 14px;">上传附件</el-button>(仅支持pdf文件格式)
          <div>
            <div v-for="(item, index) in fileList" :key="item.id" class="file-list">
              <span class="fileName">{{item.fileName}}</span>
              <span class="file-action" @click="previewFile(item.id)">预览</span>
              <span class="file-action" @click="downloadFile(item.id)">下载</span>
              <span class="file-action" @click="removeFile(index)" v-if="!isCheckDetail">删除</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="是否推广">
          <el-radio-group v-model="activityForm.isExtension">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动类别" :required="activityForm.isExtension === 0" prop="activityType">
          <el-select v-model="activityForm.activityType" :disabled="activityForm.isExtension === 1">
            <el-option :value="1" label="A类"></el-option>
            <el-option :value="2" label="B类"></el-option>
            <el-option :value="3" label="C类"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推广活动图">
          <uploadImgBtn
            :value="activityForm.extensionImg"
            @upload="(result) => {activityForm.extensionImg = result.value}"
            :disabled="isCheckDetail">
          </uploadImgBtn>
        </el-form-item>
        <el-form-item label="报名活动图">
          <uploadImgBtn
            :value="activityForm.signUpImg"
            @upload="(result) => {activityForm.signUpImg = result.value}"
            :disabled="isCheckDetail">
          </uploadImgBtn>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info :title="exportTitle" :visible.sync="showExportDialog" :confirmLoading="exportLoading" @confirm="exportActivity" confirmText="确定导出">
      <p class="timeTitle">选择统计时间</p>
      <date-range-picker :value="activityTime" @getChange="getActivityTime" :clearable="true" :disabledAfter="disabledAfter" :maxRange="92"></date-range-picker>
    </dialog-info>
    <el-dialog
      @close="URL && URL.revokeObjectURL(this.pdfLink)"
      :visible.sync="showPdfVisible"
      width="60%"
      center>
      <embed :src="pdfLink" width="100%" height="600"/>
    </el-dialog>
  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import addressSelect from '@/components/addressSelect'
import uploadImgBtn from '@/components/upload/uploadImgBtn'
import { downJumpConfirm } from '@/assets/js/utils'
export default {
  name: 'subsidyActivityManage',
  components: {
    dateRangePicker: dateRangePicker,
    pagination: pagination,
    dialogInfo: dialogInfo,
    addressSelect: addressSelect,
    uploadImgBtn: uploadImgBtn
  },
  data () {
    return {
      isBearTaxMap: {
        0: '商户',
        1: '银行',
        2: '一代'
      },
      disabledAfter: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00:00`).getTime() - 1000,
      searchLoading: false,
      searchForm: {
        activityId: '',
        name: '',
        activityType: '',
        subType: '',
        personTaxObj: '',
        // merchantCode: '',
        // agentId: '',
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      activityList: [],
      showDialog: false,
      editLoading: false,
      typeList: [
        {
          id: 10,
          text: '银行补贴活动-月返'
        },
        {
          id: 20,
          text: '银行补贴活动-实时返'
        },
        {
          id: 30,
          text: '银行补贴活动-实时返非0费率'
        }
      ],
      activityForm: {
        code: '',
        name: '',
        type: 10,
        startTime: '',
        endTime: '',
        desc: '',
        bankCode: '',
        agentIds: '',
        agentScope: 0,
        activityTime: [],
        capitalPoolCode: '',
        allowanceFeeRate: '',
        debitFeeRate: '', // 借记卡费率
        creditFeeRate: '', // 贷记卡卡费率
        maxAllowance: undefined, // 单笔封顶手续费,
        maxAllowanceT0: undefined, // 单笔封顶手续费T0
        subType: 0, // 0不提供，10上门开卡，20邮寄银行卡
        cardBinLength: '',
        cardBins: '',
        displaySwitch: 0,
        isAllProvince: 1,
        activityAddress: {
          provinceName: '',
          provinceNo: '',
          cityName: [],
          cityNo: []
        },
        zfbFeeRate: '', // 支付宝补贴费率
        wxFeeRate: '', // 微信支付补贴费率
        cloudPayDbasicFeeRate: '', // 云闪付补贴费率,d+1费率<1000
        cloudPayDoverflowFeeRate: '', // 云闪付补贴费率,d+1费率>=1000
        allowanceAmountMin: 0, // 补贴规则金额范围最小值
        allowanceAmountMax: 0, // 补贴规则金额范围最大值
        allowanceAmountLimit: 1, // 0:存量初始,1:不限制,2:自定义
        isExtension: 1, // 是否推广: 0是 1否
        activityType: '', // 活动类型 1:A 2:B 3:C
        isBearTax: 1,
        taxPointRatio: '',
        signUpImg: '', // 报名图片
        extensionImg: '', // 推广图片
        quotaPeriodType: 1, // 额度包周期类型 默认为自然月 :1-自然月；2-跨月
        periodBeginDate: 2, // 额度包周期开始日期 2-28 默认从二号开始
        creditAllowanceCap: '',
        capMonthStart: undefined,
        capMonthEnd: undefined,
        deductionType: 1, // 1 商户补贴金额， 2 银行出资金额
        advanceType: 0, // 0 无， 1 代理商垫资
        advanceAgent: '', // 参与垫资代理商编号
        settleType: ['0'], // 补贴对象
        personTaxObj: 1,
        personTaxCommission: 0,
        enterpriseTaxObj: '',
        enterpriseMerchantTaxCommission: '', // 对公结算商户承担税点比例
        enterpriseBankTaxCommission: '', // 对公结算银行承担税点比例
        enterpriseAgentTaxCommission: '', // 对公结算一代承担税点比例
        enterpriseTaxer: {
          bankSelected: false,
          topAgentSelected: false,
          merchantSelected: false
        }
      },
      bankList: [],
      isAllAgent: false,
      isCheckDetail: false,
      ruleData: {
        bankSelected: [{
          validator: (rule, value, callback) => {
            const isSelected = this.isEnterpriseTaxerSelected()
            const { bankSelected } = this.activityForm.enterpriseTaxer
            if (!isSelected) {
              callback(new Error('商户对公结算的税点承担对象至少选一个'))
            } else {
              callback()
            }
            if (bankSelected) {
              this.clearValidate(['topAgentSelected', 'merchantSelected'])
            }
          },
          trigger: 'change'
        }],
        topAgentSelected: [{
          validator: (rule, value, callback) => {
            const isSelected = this.isEnterpriseTaxerSelected()
            const { topAgentSelected } = this.activityForm.enterpriseTaxer
            if (!isSelected) {
              callback(new Error('商户对公结算的税点承担对象至少选一个'))
            } else {
              callback()
            }
            if (topAgentSelected) {
              this.clearValidate(['bankSelected', 'merchantSelected'])
            }
          },
          trigger: 'change'
        }],
        merchantSelected: [{
          validator: (rule, value, callback) => {
            const isSelected = this.isEnterpriseTaxerSelected()
            const { merchantSelected } = this.activityForm.enterpriseTaxer
            if (!isSelected) {
              callback(new Error('商户对公结算的税点承担对象至少选一个'))
            } else {
              callback()
            }
            if (merchantSelected) {
              this.clearValidate(['topAgentSelected', 'bankSelected'])
            }
          },
          trigger: 'change'
        }],
        personTaxCommission: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择税点比例'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'change'
        }],
        enterpriseMerchantTaxCommission: [{
          // validator: (rule, value, callback) => {
          //   const { merchantSelected } = this.activityForm.enterpriseTaxer
          //   if (merchantSelected && ((!value && value !== 0) || value > 30)) {
          //     callback(new Error('请输入0-30%税点'))
          //   } else {
          //     callback()
          //   }
          // },
          validator: (rule, value, callback) => {
            const { merchantSelected } = this.activityForm.enterpriseTaxer
            this.validateEnterpriseTaxCommission(rule, value, callback, merchantSelected)
          },
          trigger: 'blur'
        }],
        enterpriseBankTaxCommission: [{
          validator: (rule, value, callback) => {
            const { bankSelected } = this.activityForm.enterpriseTaxer
            this.validateEnterpriseTaxCommission(rule, value, callback, bankSelected)
          },
          trigger: 'blur'
        }],
        enterpriseAgentTaxCommission: [{
          validator: (rule, value, callback) => {
            const { topAgentSelected } = this.activityForm.enterpriseTaxer
            this.validateEnterpriseTaxCommission(rule, value, callback, topAgentSelected)
          },
          trigger: 'blur'
        }],
        name: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入活动名称'))
            } else {
              if ((/^.{1,20}$/.test(value))) {
                callback()
              } else {
                callback(new Error('请输入1-20位的活动名称'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        activityTime: [{
          required: true,
          trigger: 'change',
          message: '请设置活动起止时间'
        }],
        desc: [{
          validator: (rule, value, callback) => {
            if (value !== '' && !(/^.{1,500}$/.test(value))) {
              callback(new Error('活动说明不能超过500个字'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        agentIds: [{
          validator: (rule, value, callback) => {
            if (this.activityForm.agentScope === 1 && !(/^\d+(,\d+)*,?$/.test(value))) {
              callback(new Error('请输入活动代理商id，用英文逗号隔开'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        capitalPoolCode: [{
          validator: (rule, value, callback) => {
            if ([20, 30].includes(this.activityForm.type) && value === '') {
              callback(new Error('请输入资金池编号'))
            } else if (value && !(/\d*$/.test(value))) {
              callback(new Error('请输入正确格式的资金池编号'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
          required: true
        }],
        advanceAgent: [{
          validator: (rule, value, callback) => {
            if (this.activityForm.advanceType === 1 && !(/^\d+(,\d+)*,?$/.test(value))) {
              callback(new Error('请输入代理商编号，多个则用英文逗号区分'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        allowanceFeeRate: [{
          validator: (rule, value, callback) => {
            // if (this.activityForm.type === 20 && value === '') {
            //   callback(new Error('请输入扫码补贴费率'))
            // } else
            if (value && (parseFloat(value * 1000) / 1000 < 0 || parseFloat(value * 1000) / 1000 > 0.600)) {
              callback(new Error('请输入0-0.600的三位小数扫码补贴费率'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        creditFeeRate: [{
          validator: (rule, value, callback) => {
            // if (this.activityForm.type === 20 && value === '') {
            //   callback(new Error('请输入刷卡-贷记卡补贴费率'))
            // } else
            if (value && (parseFloat(value * 1000) / 1000 < 0.210 || parseFloat(value * 1000) / 1000 > 0.600)) {
              callback(new Error('请输入0.210-0.600的三位小数刷卡-贷记卡补贴费率'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        debitFeeRate: [{
          validator: (rule, value, callback) => {
            // if (this.activityForm.type === 20 && value === '') {
            //   callback(new Error('请输入刷卡-借记卡补贴费率'))
            // } else
            if (value && (parseFloat(value * 1000) / 1000 < 0.210 || parseFloat(value * 1000) / 1000 > 0.600)) {
              callback(new Error('请输入0.210-0.600的三位小数刷卡-借记卡补贴费率'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        maxAllowance: [{
          validator: (rule, value, callback) => {
            // if (this.activityForm.type === 20 && value === '') {
            //   callback(new Error('请输入单笔封顶手续费'))
            // } else
            const { maxAllowanceT0 } = this.activityForm
            if ((value && (!/^[1-9]\d*$/.test(value) || parseInt(value) < 1)) || value === 0) {
              callback(new Error('请输入正整数封顶手续费'))
            } else if (!value && this.activityForm.debitFeeRate && !maxAllowanceT0) {
              callback(new Error('刷卡-借记卡补贴费率和T0或T1单笔封顶手续费必须同时输入'))
            } else {
              callback()
            }
            if (value && !maxAllowanceT0) {
              this.validateField('maxAllowanceT0')
            }
          },
          trigger: 'blur'
        }],
        maxAllowanceT0: [{
          validator: (rule, value, callback) => {
            const { maxAllowance } = this.activityForm
            if ((value && (!/^[1-9]\d*$/.test(value) || parseInt(value) < 1)) || value === 0) {
              callback(new Error('请输入正整数封顶手续费'))
            } else if (!value && this.activityForm.debitFeeRate && !maxAllowance) {
              callback(new Error('刷卡-借记卡补贴费率和T0或T1单笔封顶手续费必须同时输入'))
            } else {
              callback()
            }
            if (value && !maxAllowance) {
              this.validateField('maxAllowance')
            }
          },
          trigger: 'blur'
        }],
        cardBinLength: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入卡bin位数'))
            } else if (value && (!/^[1-9]\d{0,1}$/.test(value) || parseInt(value) < 1 || parseInt(value) > 16)) {
              callback(new Error('请输入1-16之间的整数卡bin位数'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        cardBins: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入活动卡bin'))
            } else {
              const reg = new RegExp('^\\d{' + this.activityForm.cardBinLength + '}(,\\d{' + this.activityForm.cardBinLength + '})*,?$')
              if (reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的卡bin，用英文逗号,分隔'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        allowanceAmountLimit: [{
          validator: (rule, value, callback) => {
            if (value === 2) {
              if ((this.activityForm.allowanceAmountMin !== 0 && !this.activityForm.allowanceAmountMin) || (this.activityForm.allowanceAmountMax !== 0 && !this.activityForm.allowanceAmountMax)) {
                callback(new Error('请输入可交易单笔交易金额范围'))
              } else if (this.activityForm.allowanceAmountMax < this.activityForm.allowanceAmountMin) {
                callback(new Error('可交易单笔交易金额范围最大值不能小于最小值'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        activityType: [{
          validator: (rule, value, callback) => {
            if (this.activityForm.isExtension === 0) {
              if (!value) {
                callback(new Error('请选择推广活动类型'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          },
          trigger: 'change',
          message: '请选择推广活动类型'
        }],
        isBearTax: [{
          message: '请选择是否承担税点',
          required: true,
          trigger: 'blur'
        }],
        deductionType: [{
          message: '请选择额度包扣减模式',
          required: true,
          trigger: 'blur'
        }],
        taxPointRatio: [{
          message: '请输入发票税点比例',
          required: true,
          trigger: 'blur'
        }],
        creditAllowanceCap: [{
          validator: (rule, value, callback) => {
            if (value && (parseFloat(value * 100) / 100 < 0 || !/^\d+(\.\d{1,2})?$/.test(value))) {
              callback(new Error('请输入大于0的两位小数刷卡贷记卡补贴封顶手续费'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        settleType: [{
          message: '请选择补贴对象',
          required: true,
          trigger: 'change'
        }]
      },
      choseAllProvince: true,
      exportTitle: '',
      showExportDialog: false,
      exportLoading: false,
      activityTime: '',
      activityTimeStart: '',
      activityTimeEnd: '',
      subsidyTable: [
        {
          tradeType: '微信',
          secondType: '',
          rateKey: 'wxFeeRate',
          error_msg: '请输入0-0.600的三位小数微信扫码补贴费率',
          error_msg2: '请输入0.000-0.600的三位小数微信扫码补贴费率'
        }, {
          tradeType: '支付宝',
          secondType: '',
          rateKey: 'zfbFeeRate',
          error_msg: '请输入0-0.600的三位小数支付宝扫码补贴费率',
          error_msg2: '请输入0.000-0.600的三位小数支付宝扫码补贴费率'
        }, {
          tradeType: '云闪付',
          secondType: 'D+1费率>1000元',
          rateKey: 'cloudPayDoverflowFeeRate',
          error_msg: '请输入0-0.600的三位小数云闪付扫码补贴费率',
          error_msg2: '请输入0.000-0.600的三位小数云闪付扫码补贴费率'
        }, {
          tradeType: '云闪付',
          secondType: 'D+1费率≤1000元',
          rateKey: 'cloudPayDbasicFeeRate',
          error_msg: '请输入0-0.600的三位小数云闪付扫码补贴费率',
          error_msg2: '请输入0.000-0.600的三位小数云闪付扫码补贴费率'
        }, {
          tradeType: '刷卡',
          secondType: '借记卡',
          rateKey: 'debitFeeRate',
          error_msg: '请输入0.210-0.600的三位小数刷卡-借记卡补贴费率',
          error_msg2: '请输入0.000-0.600的三位小数刷卡-借记卡补贴费率'
        }, {
          tradeType: '刷卡',
          secondType: '贷记卡',
          rateKey: 'creditFeeRate',
          error_msg: '请输入0.210-0.600的三位小数刷卡-贷记卡补贴费率',
          error_msg2: '请输入0.000-0.600的三位小数刷卡-贷记卡补贴费率'
        }
      ],
      fileList: [],
      uploadLoading: false,
      pdfLink: '',
      showPdfVisible: false,
      statusList: [{
        text: '未上架',
        value: 1
      }, {
        text: '进行中',
        value: 2
      }, {
        text: '已下架',
        value: 3
      }, {
        text: '已过期',
        value: 4
      }],
      periodDateList: Array(27).fill('').map((item, index) => index + 2),
      subTypeList: [
        {
          id: 0,
          text: '不提供'
        },
        {
          id: 10,
          text: '上门开卡'
        },
        {
          id: 20,
          text: '邮寄工资卡'
        },
        {
          id: 30,
          text: '网点开卡'
        },
        {
          id: 40,
          text: '上门/网点开卡'
        }
      ],
      openCardDemandList: [],
      settleDisabled: false, // 补贴给代理商禁用
      capConfig: [{
        tradeType: '借记卡',
        payWay: 'T0',
        subsidyKey: 'maxAllowanceT0'
      }, {
        tradeType: '借记卡',
        payWay: 'T1',
        subsidyKey: 'maxAllowance'
      }],
      taxConfig: [{
        accountType: '商户对私结算',
        subsidyKey: 'maxAllowanceT0'
      }, {
        accountType: '商户对公结算',
        taxRateKey: 'enterpriseBankTaxCommission', // 税点比例
        taxerKey: 'bankSelected', // 税点承担对象
        taxer: '银行'
      }, {
        accountType: '商户对公结算',
        taxRateKey: 'enterpriseAgentTaxCommission',
        taxerKey: 'topAgentSelected',
        taxer: '一代'
      }, {
        accountType: '商户对公结算',
        taxRateKey: 'enterpriseMerchantTaxCommission',
        taxerKey: 'merchantSelected',
        taxer: '商户'
      }],
      taxerList: [
        { value: 1, label: '银行' },
        { value: 2, label: '一代' },
        { value: 0, label: '商户' }
      ],
      taxRateList: [
        { value: 0, label: '0' },
        { value: 6, label: '6' },
        { value: 10, label: '10' }
      ]
    }
  },
  watch: {
    'activityForm.isAllProvince': {
      handler (val) {
        if (val === 1) {
          this.activityForm.activityAddress = this.$options.data().activityForm.activityAddress
          this.choseAllProvince = true
        } else {
          this.choseAllProvince = false
        }
        const that = this
        setTimeout(function () {
          that.$refs.addressForm.$refs.form.clearValidate()
        }, 100)
      }
    },
    'activityForm.capMonthStart': {
      handler (val) {
        if (val > this.activityForm.capMonthEnd) {
          this.activityForm.capMonthEnd = val
        }
      }
    },
    'activityForm.type': {
      handler (val) {
        if (val === 20 || val === 30) {
          this.settleDisabled = true
          this.activityForm.settleType = this.activityForm.settleType.filter(item => item !== '10')
        } else {
          this.settleDisabled = false
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    validateField (fieldName) {
      this.$refs.activityForm.validateField(fieldName, () => {})
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    validateEnterpriseTaxCommission (rule, value, callback, isSelected) {
      if (isSelected && ((!value && value !== 0) || value > 30)) {
        callback(new Error('请输入0-30%税点'))
        return
      } else if (!isSelected && value > 30) {
        callback(new Error('请输入0-30%税点'))
        return
      }
      callback()
    },
    clearValidate (fieldName) {
      this.$refs.activityForm.clearValidate(fieldName, () => {})
    },
    // 判断商户对公结算是否选择了税点承担对象
    isEnterpriseTaxerSelected () {
      const { bankSelected, topAgentSelected, merchantSelected } = this.activityForm.enterpriseTaxer
      if (!bankSelected && !topAgentSelected && !merchantSelected) {
        return false
      } else {
        return true
      }
    },
    taxConfigSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 1) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else if (rowIndex > 1) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    async init () {
      await this.getBankList()
      await this.getList()
    },
    getList () {
      this.searchLoading = true
      this.$axios.post(this.$api.activityList, this.searchForm).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.total = res.data.count
          this.activityList = res.data.list
        }
      })
    },
    search () {
      this.searchForm.pageNo = 1
      this.getList()
    },
    getTypeText (type) {
      const result = this.typeList.filter(item => {
        return item.id === type
      })
      if (result.length === 1) {
        return result[0].text
      } else {
        return '未知'
      }
    },
    getSubTypeText (type) {
      const result = this.subTypeList.filter(item => {
        return item.id === type
      })
      if (result.length === 1) {
        return result[0].text
      } else {
        return '未知'
      }
    },
    getTimeChange (value) {
      this.activityForm.activityTime = value
      this.activityForm.startTime = value[0]
      this.activityForm.endTime = value[1]
    },
    checkDetails (row) {
      this.isCheckDetail = true
      this.setActivityForm(row)
      this.showDialog = true
    },
    editActivity (row) {
      this.isCheckDetail = false
      this.setActivityForm(row)
      this.showDialog = true
      const that = this
      setTimeout(function () {
        that.$refs.activityForm.clearValidate()
        that.$refs.addressForm.$refs.form.clearValidate()
      }, 100)
    },
    toAddActivity () {
      this.showDialog = true
      this.isCheckDetail = false
      this.activityForm = this.$options.data().activityForm
      this.activityForm.bankCode = this.bankList[0].code
      this.activityForm.activityTime = []
      const that = this
      setTimeout(function () {
        that.$refs.activityForm.clearValidate()
        that.$refs.addressForm.$refs.form.clearValidate()
      }, 100)
    },
    merchantManage (row) {
      this.$router.push({
        name: 'subsidyMerchant',
        query: {
          id: row.code,
          name: row.name,
          type: row.type, // 活动类型 10 月返 20 实时返 30 非0实时返
          subType: row.subType, // 是否提供开卡服务，用于控制是否可录入待开卡商户
          openCardDemand: row.openCardDemand,
          bankCode: row.bankCode
        },
        params: {
          merchantId: this.searchForm.merchantCode,
          agentId: this.searchForm.agentId
        }
      })
    },
    quotaMerchantManage (row) {
      this.$router.push({
        name: 'quotaMerchant',
        query: {
          id: row.code,
          name: row.name,
          type: row.type,
          period: row.quotaPeriodType === 1 ? 1 : row.periodBeginDate
        },
        params: {
          merchantCode: this.searchForm.merchantCode,
          agentId: this.searchForm.agentId
        }
      })
    },
    getBankList () {
      return new Promise((resolve, reject) => {
        this.$axios.post(this.$api.getEnableBankList, {}).then(res => {
          if (res.respCode === '0') {
            this.bankList = res.data.list
          }
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    transformEnterpriseTaxObj () {
      let result = ''
      const { bankSelected, topAgentSelected, merchantSelected } = this.activityForm.enterpriseTaxer
      if (bankSelected) {
        result += '1,'
      }
      if (topAgentSelected) {
        result += '2,'
      }
      if (merchantSelected) {
        result += '0,'
      }
      return result.slice(0, result.length - 1)
    },
    submitActivity () {
      let addressResult
      this.$refs.addressForm.$refs.form.validate((valid) => {
        addressResult = valid
      })
      if (!addressResult) {
        this.$message({
          type: 'warning',
          message: '请完善信息后提交！'
        })
        return
      }
      // if ([20, 30].includes(this.activityForm.type) && (this.activityForm.debitFeeRate || this.activityForm.creditFeeRate)) {
      //   if (!this.activityForm.debitFeeRate || !this.activityForm.creditFeeRate) {
      //     this.$message({
      //       message: '刷卡-借记卡补贴费率和单笔封顶手续费必须同时输入',
      //       type: 'error'
      //     })
      //     return
      //   }
      // }
      this.$refs.activityForm.validate((valid) => {
        if (valid) {
          if (this.editLoading) {
            return
          }
          this.editLoading = true
          let api
          let message
          if (this.activityForm.code) {
            api = 'editActivity'
            message = '编辑成功！'
          } else {
            api = 'addActivity'
            message = '新增成功！'
          }
          const params = JSON.parse(JSON.stringify(this.activityForm))
          params.zfbFeeRate = params.zfbFeeRate && parseFloat(params.zfbFeeRate).toFixed(3)
          params.wxFeeRate = params.wxFeeRate && parseFloat(params.wxFeeRate).toFixed(3)
          params.cloudPayDbasicFeeRate = params.cloudPayDbasicFeeRate && parseFloat(params.cloudPayDbasicFeeRate).toFixed(3)
          params.cloudPayDoverflowFeeRate = params.cloudPayDoverflowFeeRate && parseFloat(params.cloudPayDoverflowFeeRate).toFixed(3)
          params.creditFeeRate = params.creditFeeRate && parseFloat(params.creditFeeRate).toFixed(3)
          params.debitFeeRate = params.debitFeeRate && parseFloat(params.debitFeeRate).toFixed(3)
          params.fileIds = this.fileList.map(item => item.id)
          params.taxPointRatio = params.taxPointRatio && parseFloat(params.taxPointRatio)
          params.periodBeginDate = params.quotaPeriodType === 2 ? params.periodBeginDate : ''
          params.openCardDemand = this.openCardDemandList.reduce((a, b) => a + b, 0)
          params.settleType = this.activityForm.settleType.join(',')
          params.capMonthStart = params.capMonthStart || ''
          params.capMonthEnd = params.capMonthEnd || ''
          params.maxAllowance = params.maxAllowance || 0
          params.maxAllowanceT0 = params.maxAllowanceT0 || 0
          params.enterpriseTaxObj = this.transformEnterpriseTaxObj()
          delete params.enterpriseTaxer
          this.$axios.post(this.$api[api], params).then(res => {
            this.editLoading = false
            if (res.respCode === '0') {
              this.showDialog = false
              this.$message({
                type: 'success',
                message: message
              })
              this.getList()
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    getAddress (val) {
      this.activityForm.activityAddress = val
    },
    changeAddressType (val) {
      this.activityForm.activityAddress = this.$options.data().activityForm.activityAddress
    },
    exportActivity () {
      if (this.activityTimeStart === '') {
        this.$message({
          type: 'warning',
          message: '请选择完整导出时间！'
        })
        return
      }
      if (this.exportLoading) {
        return true
      }
      this.exportLoading = true
      const params = {
        startTime: this.activityTimeStart,
        endTime: this.activityTimeEnd
      }
      this.$axios.post(this.$api.exportAgentActivity, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
        this.activityTimeStart = ''
        this.activityTimeEnd = ''
        this.activityTime = []
        this.showExportDialog = false
      }).catch(e => {
        this.exportLoading = false
      })
    },
    /**
     * @description 导出交易起止时间
     * @params {Array} value 选中时间数组
     */
    getActivityTime (value) {
      if (value != null) {
        this.activityTimeStart = value[0]
        // this.activityTimeEnd = value[1].substr(0, 10) + ' 23:59:59'
        this.activityTimeEnd = value[1]
        this.activityTime = [this.activityTimeStart, this.activityTimeEnd]
      } else {
        this.activityTimeStart = ''
        this.activityTimeEnd = ''
        this.activityTime = []
      }
    },
    toExportMonthActivity () {
      this.exportTitle = '导出代理商活动数据【月返】'
      this.activityTime = []
      this.activityTimeStart = ''
      this.activityTimeEnd = ''
      this.showExportDialog = true
    },
    exportActivityData () {
      const params = Object.assign({}, this.searchForm)
      this.$axios.post(this.$api.activityDataExport, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    exportActivityConfigData () {
      const params = Object.assign({}, this.searchForm)
      this.$axios.post(this.$api.activityConfigDataExport, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    editTemplateTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (!row.secondType) {
        if (columnIndex === 0) {
          return [1, 2]
        } else if (columnIndex === 1) {
          return [0, 0]
        }
      }
      if (columnIndex === 0 && ['云闪付', '刷卡'].includes(row.tradeType)) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    hideHeader ({ rowIndex }) {
      if (rowIndex === 1) {
        return { display: 'none' }
      }
    },
    onRateBlur (row) {
      // 实时返非0费率的银行活动, 设置补贴规则: 费率配置阈值范围最小阈值设置为0
      if (this.activityForm[row.rateKey] !== '' && !/^\d{0,1,2}(\.\d{1,3})?$/.test(this.activityForm[row.rateKey])) {
        this.$message({
          message: this.activityForm.type === 30 ? row.error_msg2 : row.error_msg,
          type: 'error'
        })
        this.activityForm[row.rateKey] = ''
        return
      }
      if (!['creditFeeRate', 'debitFeeRate'].includes(row.rateKey)) {
        if (this.activityForm[row.rateKey] && (parseFloat(this.activityForm[row.rateKey] * 1000) / 1000 < (this.activityForm.type === 30 ? 0 : 0.2) || parseFloat(this.activityForm[row.rateKey] * 1000) / 1000 > 0.6)) {
          this.$message({
            message: this.activityForm.type === 30 ? row.error_msg2 : row.error_msg,
            type: 'error'
          })
          this.activityForm[row.rateKey] = ''
        }
      }
      if (['creditFeeRate', 'debitFeeRate'].includes(row.rateKey)) {
        if (this.activityForm[row.rateKey] && (parseFloat(this.activityForm[row.rateKey] * 1000) / 1000 < (this.activityForm.type === 30 ? 0 : 0.21) || parseFloat(this.activityForm[row.rateKey] * 1000) / 1000 > 0.6)) {
          this.$message({
            message: this.activityForm.type === 30 ? row.error_msg2 : row.error_msg,
            type: 'error'
          })
          this.activityForm[row.rateKey] = ''
        }
      }
      // }
    },
    getFile (event, type) {
      const files = event.target.files
      this.uploadLoading = true
      if (files[0].name.indexOf('pdf') < 0) {
        this.$message({
          message: '请上传.pdf格式的文件！',
          type: 'warning'
        })
        this.uploadLoading = false
        event.target.value = null
        return
      }
      const data = new FormData()
      data.append('file', files[0])
      this.$axios.post(this.$api.uploadPdf, data).then(data => {
        this.uploadLoading = false
        event.target.value = null
        if (parseInt(data.respCode) === 0) {
          this.fileList.push(data.data)
        }
      })
    },
    downloadFile (fileId) {
      this.$axios.post(this.$api.downloadFile, { id: fileId }).then(data => {
        if (parseInt(data.respCode) === 0) {
          this.$message({
            message: '文件下载成功，请前往下载中心查看',
            type: 'success'
          })
        }
      })
    },
    removeFile (index) {
      this.$confirm('是否确认删除该文件？', '温馨提醒', {
      }).then(() => {
        this.fileList.splice(index, 1)
      })
    },
    previewFile (fileId) {
      this.$axios.get(this.$api.previewActivity, {
        params: {
          fileId: fileId
        },
        responseType: 'blob'
      }).then(res => {
        if ((res && res.respCode) || !res) {
          return
        }
        const blob = new Blob([res], {
          type: 'application/pdf;charset=utf-8'
        })
        this.pdfLink = URL.createObjectURL(blob)
        this.showPdfVisible = true
      })
    },
    closeActivityForm () {
      this.settleDisabled = false
      this.activityForm = this.$options.data().activityForm
      this.fileList = []
      this.openCardDemandList = []
    },
    setActivityForm (row) {
      this.activityForm = { ...this.activityForm, ...JSON.parse(JSON.stringify(row)) }
      const enterpriseTaxObj = row.enterpriseTaxObj ?? ''
      this.activityForm.enterpriseTaxer = {
        bankSelected: enterpriseTaxObj.includes('1'),
        topAgentSelected: enterpriseTaxObj.includes('2'),
        merchantSelected: enterpriseTaxObj.includes('0')
      }
      if (row.address) {
        this.activityForm.activityAddress = JSON.parse(row.address)
      }
      this.activityForm.settleType = row.settleType === '' ? [] : row.settleType.split(',')
      this.activityForm.activityTime = [row.startTime || '', row.endTime || '']
      // this.activityForm.debitFeeRate = row.debitFeeRate || ''
      // this.activityForm.creditFeeRate = row.creditFeeRate || ''
      // this.activityForm.zfbFeeRate = row.zfbFeeRate || ''
      // this.activityForm.wxFeeRate = row.wxFeeRate || ''
      this.activityForm.maxAllowance = row.maxAllowance || undefined
      this.activityForm.maxAllowanceT0 = row.maxAllowanceT0 || undefined
      // this.activityForm.cloudPayDbasicFeeRate = row.cloudPayDbasicFeeRate || ''
      // this.activityForm.cloudPayDoverflowFeeRate = row.cloudPayDoverflowFeeRate || ''
      this.activityForm.capMonthStart = row.capMonthStart || undefined
      this.activityForm.capMonthEnd = row.capMonthEnd || undefined
      this.fileList = this.activityForm.fileInfos ? this.activityForm.fileInfos.map(item => {
        return {
          id: item.fileId,
          fileName: item.fileName
        }
      }) : []
      this.activityForm.taxPointRatio = [0, 6, 10, '0', '6', '10'].includes(this.activityForm.taxPointRatio)
        ? this.activityForm.taxPointRatio
        : this.activityForm.taxPointRatio ? this.activityForm.taxPointRatio + '%' : ''
      // this.activityForm.isBearTax = [0, 1].includes(this.activityForm.isBearTax) ? this.activityForm.isBearTax : 1
      // this.activityForm.quotaPeriodType = this.activityForm.quotaPeriodType || 1
      let currentValue = this.activityForm.openCardDemand;
      [10, 1].forEach(item => {
        if (currentValue >= item) {
          this.openCardDemandList.push(item)
          currentValue -= item
        }
      })
    },
    getStatusText (activityStatus) {
      const result = this.statusList.filter(item => {
        return item.value === activityStatus
      })
      if (result.length === 1) {
        return result[0].text
      } else {
        return '未知'
      }
    },
    activityOff (row) {
      this.$confirm('是否确认下架活动', '温馨提醒').then(() => {
        this.$axios.get(this.$api.updateActivityStatus, {
          params: {
            activityStatusUpdateBefore: row.activityStatus,
            code: row.code
          }
        }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              message: '下架成功',
              showClose: true,
              type: 'success'
            })
            this.getList()
          }
        })
      })
    },
    onQuotaPeriodTypeChange (type) {
      console.log(type)
    },
    activityOn (row) {
      this.$confirm('确认是否重新上架活动', '温馨提醒').then(() => {
        this.$axios.get(this.$api.upShelves, {
          params: {
            code: row.code
          }
        }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              message: '上架成功',
              showClose: true,
              type: 'success'
            })
          }
          this.getList()
        })
      })
    },
    activityDelete (row) {
      console.log(row)
      this.$confirm('确认要删除活动？请再次确认，操作需谨慎', '温馨提醒').then(() => {
        this.$axios.get(this.$api.deleteActivity, {
          params: {
            code: row.code,
            name: row.name
          }
        }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              message: '删除成功',
              showClose: true,
              type: 'success'
            })
          }
          this.getList()
        })
      })
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios.post(this.$api.activityFuzzySearch, {
            name: queryString
          }).then(res => {
            if (res.respCode === '0') {
              var result = res.data
              cb(result)
            } else {
              result = []
              cb(result)
            }
          })
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.activityTime{
  &.el-date-editor--datetimerange.el-input__inner{
    width: 100%;
  }
}
</style>
<style lang="less" scoped>
.activityForm{
  overflow: auto;
  padding-right: 20px;
  /deep/ .el-form-item {
    margin-bottom: 28px;
  }
}
.table{
  margin-top: 20px;
  .editBtn{
    margin: 0;
  }
}
.timeTitle{
  margin-bottom: 20px;
}
.el-table input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: calc(100% - 20px);
  text-align: center;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  +span{
    height: 30px;
    line-height: 30px;
    margin-left: 5px;
  }
  &:disabled{
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed;
  }

}
.input-number {
  margin-top: 16px;
  /deep/ .el-input-number--small {
    width: 150px;
  }
}
// /deep/ .default {
//   .el-dialog__body {
//     padding: 20px 30px 0 30px;
//   };
// }
.long-content {
  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
}
.file-list {
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  .fileName {
    max-width: 260px;
    line-height: 24px;
  }
  .file-action {
    padding-left: 14px;
    color: #409EFF;
    cursor:pointer;
  }
}
.select-date {
  width: 70px;
  height: 30px;
}
.period-date {
  padding-top: 16px;
  .inner {
    margin: 0 10px;
  }
}
.maxInput {
  width: 180px;
}
.tax-config-table {
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
  /deep/ .el-form-item.is-error {
    margin-bottom: 28px;
  }
}
.private_tax_rate {
  display: flex;
  span {
    margin-left: 5px;
  }
}
</style>
